import { Either, Option } from 'funfix-core';
import { CLEAR_INSTALLABLE_APP_BY_MANUAL_URL, FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR, FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL, START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL } from '../../../actions/Installation/InstallMode/InstallableAppByManualUrl';
import { makeInstallableAppByManualUrl } from '../../../records/InstallMode/InstallableAppByManualUrlInstallMode';
import { foldInstallMode } from '../../../records/InstallMode/InstallMode';
import { mapInstallMode } from '../InstallationUtils';
const installableAppByManualUrlReducer = (state, action) => {
  switch (action.type) {
    case START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL:
      {
        const installableAppByUrlId = action.installableAppByUrlId;
        const retrievalId = action.retrievalId;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, value => value, value => value, value => value, installableAppByManualUrl => installableAppByManualUrl.set('installableAppByManualUrl', Option.some(makeInstallableAppByManualUrl({
          installableAppByUrlId,
          retrievalId
        }))), value => value));
      }
    case FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL:
      {
        const retrievalId = action.retrievalId;
        const installableApp = action.installableApp;
        const installedApp = action.installedApp;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, value => value, value => value, value => value, installableAppByManualUrl => installableAppByManualUrl.update('installableAppByManualUrl', installableAppByManualUrlOld => installableAppByManualUrlOld.map(iabmu => iabmu.retrievalId === retrievalId ? iabmu.set('installableApp', Option.some(Either.right(installableApp))).set('installedApp', installedApp) : iabmu)), value => value));
      }
    case FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR:
      {
        const retrievalId = action.retrievalId;
        const error = action.error;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, value => value, value => value, value => value, installableAppByManualUrl => installableAppByManualUrl.update('installableAppByManualUrl', installableAppByManualUrlOld => installableAppByManualUrlOld.map(iabmu => iabmu.retrievalId === retrievalId ? iabmu.set('installableApp', Option.some(Either.left(error))) : iabmu)), value => value));
      }
    case CLEAR_INSTALLABLE_APP_BY_MANUAL_URL:
      return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, value => value, value => value, value => value, installableAppByManualUrl => installableAppByManualUrl.set('installableAppByManualUrl', Option.empty()), value => value));
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
};
export default installableAppByManualUrlReducer;